import { useState } from "react";
import axios from "axios";
import * as api from "../api/index";

export const useUploadForm = (url) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [progress, setProgress] = useState(0);

  const reset = () => {
    setIsSuccess(false);
    setProgress(0);
  };

  const uploadForm = async (fileData, file, metaData) => {
    const { safeName } = makeSafeFilename(fileData.filename, 20);

    // Use safeName for blob
    const { data } = await api.createFileEntry(safeName, metaData);
    const { uploadURL, fileID } = data.data;

    // 🔹 Upload directly to Azure Blob Storage (no Authorization header needed!)
    await axios.put(uploadURL, file, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": file.type || "application/octet-stream",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.loaded / progressEvent.total) * 100;
        setProgress(progress);
      },
    });

    // 🔹 Notify backend that upload is complete
    const datacomplete = await api.uploadCompleted(fileID);

    setIsSuccess(true);
    setProgress(0);

    return datacomplete;
  };

  return { uploadForm, isSuccess, progress, reset };
};

function makeSafeFilename(originalName, maxLength = 20) {
  // Split name and extension
  const parts = originalName.split(".");
  const ext = parts.length > 1 ? "." + parts.pop() : "";
  let base = parts.join(".");

  // Sanitize: replace any character that isn't alphanumeric, dash, or underscore with '_'
  const sanitize = (s) => s.replace(/[^a-zA-Z0-9-_]/g, "_").replace(/_+/g, "_");

  base = sanitize(base);
  const safeExt = ext ? "." + sanitize(ext.slice(1)) : "";

  // Truncate base name to maxLength
  if (base.length > maxLength) {
    base = base.substring(0, maxLength);
  }

  // Trim leading/trailing underscores from base
  base = base.replace(/^_+|_+$/g, "") || "file";

  // Optional: add a short timestamp to avoid collisions after sanitization
  const stamp = Date.now().toString(36);
  const safeName = `${base}_${stamp}${safeExt}`;

  return { safeName, displayName: originalName };
}
